import styled from '@emotion/styled';
import { CircularProgress } from '@mui/material';
import { CephableIcon } from '@shared/components/core/images/icons/brand';
import { LabelXLarge } from '@shared/components/core/text/Typography';
import { useTranslation } from 'react-i18next';
import Button from '../core/button/CoreButton';
import { MixinAnimationFadeFast } from '../core/structure/DefaultStyles';

interface ISplashLoaderProps {
    text?: string;
    className?: string;
    children?: React.ReactNode;
    refreshButton?: boolean;
}

const SplashLoader = ({ text, className, children, refreshButton = false }: ISplashLoaderProps) => {
    const { t } = useTranslation();
    return (
        <SplashLoaderWrapper className={className}>
            <StyledCephableIcon />
            <SpacedProgress />
            {text && <StyledLabelXLarge>{text}</StyledLabelXLarge>}
            {children}
            {refreshButton && (
                <Button
                    onClick={() => {
                        window.location.reload();
                    }}>
                    {t('common:reload')}
                </Button>
            )}
        </SplashLoaderWrapper>
    );
};

const StyledCephableIcon = styled(CephableIcon)`
    height: 128px;
    width: 128px;
`;

const StyledLabelXLarge = styled(LabelXLarge)`
    color: ${(props) => props.theme.color.text};
`;

export const SpacedProgress = styled(CircularProgress)`
    margin: 16px;
`;
const SplashLoaderWrapper = styled.div`
    min-height: 90vh;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    ${MixinAnimationFadeFast}
    img {
        height: 128px;
        width: 128px;
    }
`;

export default SplashLoader;
